/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";

function Seo({ description, lang, meta, title, image, location: locationProp }) {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
        `
    )

    const locationHook = useLocation();
    const location = locationHook || locationProp;

    const metaDescription = description || site.siteMetadata.description;
    const defaultTitle = site.siteMetadata?.title;

    // Build canonical URL
    var currentUrl = '';
    if (location !== undefined && location.pathname) {
        currentUrl = process.env.GATSBY_SITE_URL + location.pathname;
    }

    // Remove multiple slashes and set lowercase
    currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1").toLowerCase();

    // Handle pagination - strip page- from canonical URL
    let hasPagination = false;
    if (location !== undefined && location.pathname) {
        let pageStr = location.pathname.split('page-');
        hasPagination = pageStr[1] || false;
        if (pageStr[0] !== undefined) {
            currentUrl = process.env.GATSBY_SITE_URL + pageStr[0];
        }
    }

    // Ensure trailing slash
    currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1").toLowerCase();
    if (!currentUrl.endsWith("/"))
        currentUrl += "/";

    // Robots logic:
    // - noindex if no results page or pagination
    // - index everything else
    const isNoResultPage = typeof window !== "undefined" && document.querySelector('.no-result-page');

    const robotsContent = (isNoResultPage || hasPagination)
        ? "noindex, follow"
        : "index, follow";

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
            link={[
                {
                    href: currentUrl,
                    rel: "canonical"
                }
            ]}
            meta={[
                {
                    name: "robots",
                    content: robotsContent,
                },
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:site`,
                    content: "@espace",
                },
                {
                    name: `twitter:card`,
                    content: "summary_large_image",
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:image`,
                    content: image,
                },
                {
                    name: `twitter:image:src`,
                    content: image,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
                {
                    name: `twitter:domain`,
                    content: "www.tlclondon.com",
                },
                {
                    name: `viewport`,
                    content: "width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0"
                },
            ].concat(meta)}
        />
    )
}

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default Seo